import { apiClient } from "lib/apiClient";
import {
  ICoordinate,
  IStandardGeographyDto,
  StandardGeographyTypeEnum,
} from "features/MarketAreas/types";

export type TResolveStandardGeographyPayload = {
  type: StandardGeographyTypeEnum;
  coordinate: ICoordinate;
};

export const resolveStandardGeography = async (
  payload: TResolveStandardGeographyPayload,
  signal?: AbortSignal
): Promise<IStandardGeographyDto> => {
  const response = await apiClient.post<IStandardGeographyDto>(
    "/market-areas/helper/coordinates/resolve",
    payload,
    { signal }
  );
  return response.data;
};
